<template>
	<div class="basis-page-cls">
        <section class="basis-cls_table">
			<el-checkbox v-model="isTelChannel" :disabled="!['', null, undefined].includes(data.agentCode)">电话渠道</el-checkbox>
			<br /><br />
            <div class="table">
				<table-pagination
					ref="tableItem"
                    :data="skillData"
                    :column="column"
					@selection-change="selectionChange">
					<!-- <template v-slot:level="{row}">
						<el-input-number v-model="row.level" :min="1" :max="100" size="mini"></el-input-number>
					</template>
					<template v-slot:position="{row}">
						<el-input-number v-model="row.position" :min="1" :max="100" size="mini"></el-input-number>
					</template> -->
				</table-pagination>
            </div>
        </section>
		<div slot="footer" class="dialog-footer" style="text-align: right;">
			<el-button @click="$emit('getCancelBtn')">取 消</el-button>
			<el-button v-if="['', null, undefined].includes(data.agentCode)" type="primary" @click="create">确 定</el-button>
			<el-button v-else type="primary" @click="update">确 定</el-button>
		</div>
    </div>
</template>

<script>
import { getUserSave } from 'api/user';
export default {
	props:['data'],
	watch:{
		'data':{
			handler(val){
				if(val) {
					this.isTelChannel = val?.agentCode ? true : false;
					this.getList();
				}
			},
			immediate:true
		}
	},
	data() {
		return {
			isTelChannel: false,
			skillSourceData: [],
			skillSelectData: [],
			levelList: [],
			positionList: [],
			skillData:[],
			column:[
				{ 
                    width: 50, 
					label: '权限',
                    type: 'selection', 
                    selectable: this.isDisabled
                },
				{ label: '技能组', prop: 'queueName'},
				// { label: 'Level', prop: 'level', slotScope: true},
				// { label: 'Position', prop: 'position', slotScope: true}
			],
			loading:false,
		}
	},
	methods:{
		isDisabled(row){
            if(this.isTelChannel) { 
                return 1;
            } else {
                return 0;
            }
        },
		getList(){
			let self = this;
			self.skillSelectData = [];
			self.skillSourceData = [];
			// self.skillData = [];
			self.$api.apiPostQueueSelectList({projectCode: self.data.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				self.skillData = response.data;
				if(self.data.agentCode) {
					self.$api.apiPostAgentTierList({agentName: self.data.agentCode}).then(res => {
						if(res.errcode != 0) return;
						for(const item of self.skillData) {
							for(const _item of res.data) {
								self.skillSelectData.push(_item.queue);
								self.skillSourceData.push(_item.queue);
								if(item.queueName === _item.queue) {
									self.$refs.tableItem.$refs.elTable.toggleRowSelection(item);
								}
								// self.$set(item, 'level', _item.level);
								// self.$set(item, 'position', _item.position);
								// self.skillData.push(item);
							}
						}
					});
				}
			});
		},
		selectionChange(rows){
			this.skillSelectData = [];
			// this.levelList = [];
			// this.positionList = [];
			for(const item of rows) {
				this.skillSelectData.push(item.queueName);
				// this.levelList.push(item.level);
				// this.positionList.push(item.position);
			}
		},
		create() {
			let self = this;
			if(!self.isTelChannel) {
				self.$message.error('请勾选电话渠道');
				return;
			}
			if(self.skillSelectData.length === 0) {
				self.$message.error('请勾选技能组');
				return;
			}
			self.$api.apiPostCreateAgentAndExtens({
				account: self.data.account,
				callSwitchType: 'spbx',
				createQueueNames: self.skillSelectData.toString(),
				nickname: self.data.nickname,
				projectCode: self.data.brandIdentify
			}).then(response => {
				if(response.errcode != 0) return;
				self.data.agentCode = response.data.agentName;
				self.data.deviceCode = response.data.ext;
				getUserSave('update', self.data).then(res => {
					if(res.errcode != 0) return;
					// self.$emit('getCancelBtn', true);
					self.$emit("createCB")
					self.$message.success('修改成功');
				});
			});
		},
		async update() {
			this.skillSelectData = this.skillSelectData.toString();
			this.skillSelectData = this.skillSelectData.split(',');
			let addArr = [];
			let deleteArr = [];
			for(const item of this.skillSelectData) {
				if(!this.skillSourceData.includes(item)) {
					addArr.push(item);
				}
			}
			this.$api.apiPostAddTierAccount({
				projectCode: this.data.brandIdentify, 
				account: this.data.account,
				queueName: addArr.toString(),
				// level: this.levelList.toString(),
				// position: this.positionList.toString(),
			});
			for(const _item of this.skillSourceData.concat(addArr)) {
				if(!this.skillSelectData.includes(_item)) {
					deleteArr.push(_item);
				}
			}
			this.$api.apiPostDeleteTierAccount({projectCode: this.data.brandIdentify, account: this.data.account, queueName: deleteArr.toString()});
			this.$emit('getCancelBtn', true);
			this.$message.success('修改成功');
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__header-wrapper .el-checkbox {
	display: none;
}
</style>